export const fakeToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiZmFrZS1jbGllbnQtaWQtMTIzIl0sImF6cCI6ImZha2UtY2xpZW50LWlkLTEyMyIsImNyZWF0ZWRUaW1lIjoiMjAyNS0wNi0wNVQxMToxOToxNiswODowMCIsImV4cCI6MTc0OTE5OTQ0NywiaWF0IjoxNzQ5MTk1ODQ3LCJpZCI6InJhbmRvbS1pZC1hYmMxMjMiLCJpc3MiOiJodHRwczovL2V4YW1wbGUuY29tIiwianRpIjoianRpLXJhbmRvbS05ODciLCJuYW1lIjoiRGV2ZWxvcG1lbnQgYW5kIHRlc3RpbmciLCJuYmYiOjE3NDkxOTU4NDcsIm5vbmNlIjoiIiwic2NvcGUiOiJwcm9maWxlIiwic3ViIjoic3ViLWZha2UtdXVpZCIsInRhZyI6InRlc3QtZ3JvdXAiLCJ0b2tlblR5cGUiOiJhY2Nlc3MtdG9rZW4ifQ.t4cZLOl6Os6ZpQaGF_1Yju3YoTgQTnEgl32HmwyxFt4";

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/site/dashboard';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 303;
export const MINI_DRAWER_WIDTH = 68;

export let SimpleLayoutType;

(function (SimpleLayoutType) {
  SimpleLayoutType['SIMPLE'] = 'simple';
  SimpleLayoutType['LANDING'] = 'landing';
})(SimpleLayoutType || (SimpleLayoutType = {}));

export let ThemeMode;

(function (ThemeMode) {
  ThemeMode['LIGHT'] = 'light';
  ThemeMode['DARK'] = 'dark';
})(ThemeMode || (ThemeMode = {}));

export let MenuOrientation;

(function (MenuOrientation) {
  MenuOrientation['VERTICAL'] = 'vertical';
  MenuOrientation['HORIZONTAL'] = 'horizontal';
})(MenuOrientation || (MenuOrientation = {}));

export let ThemeDirection;

(function (ThemeDirection) {
  ThemeDirection['LTR'] = 'ltr';
  ThemeDirection['RTL'] = 'rtl';
})(ThemeDirection || (ThemeDirection = {}));

export let NavActionType;

(function (NavActionType) {
  NavActionType['FUNCTION'] = 'function';
  NavActionType['LINK'] = 'link';
})(NavActionType || (NavActionType = {}));

// ==============================|| THEME CONFIG ||============================== //

const config = {
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR
};

export default config;
